import { render, staticRenderFns } from "./So.vue?vue&type=template&id=6066ca8b&scoped=true&"
import script from "./So.vue?vue&type=script&lang=js&"
export * from "./So.vue?vue&type=script&lang=js&"
import style0 from "./So.vue?vue&type=style&index=0&id=6066ca8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066ca8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
